import { apiRequest, HttpMethods } from 'common-src/features/rest';

export const pushAppointmentsApi = async (patientId, portalPatientId) => {
  const response = await apiRequest({
    endpoint: 'patientPortalBackend/pushAppointments',
    method: HttpMethods.Post,
    body: { patient_id: patientId, portal_patient_id: portalPatientId },
  });
  let data = null;
  try {
    data = await response.json();
  } catch (jsonErr) {
    data = { message: await response.text() };
  }
  return {
    ok: response.ok,
    data,
    status: response.status,
  };
};
